<template>
  <div>
    <b-list-group>
      <b-row>
        <div v-for="complexFilter in complexFilters" :key="complexFilter._id" class="col-12 col-md-6 mb-4">
          <b-list-group-item
            :class="[
              'complex-filter-list-item',
              `${selectedComplexFilters.includes(complexFilter._id) ? 'selected' : ''}`
            ]"
            @click="selectComplexFilter(complexFilter._id)"
            >{{ complexFilter.name }}</b-list-group-item
          >
        </div>
      </b-row>
    </b-list-group>
  </div>
</template>

<script>
export default {
  props: {
    complexFilters: { type: Array, required: true },
    preSelection: { type: Array }
  },
  data() {
    return {
      selectedComplexFilters: []
    }
  },
  methods: {
    selectComplexFilter(_id) {
      if (this.selectedComplexFilters.includes(_id)) {
        this.selectedComplexFilters = this.selectedComplexFilters.filter(id => id !== _id)
      } else {
        this.selectedComplexFilters.push(_id)
      }
      this.$emit('new-selected-complex-filters', this.selectedComplexFilters)
    }
  },
  mounted() {
    if (this.preSelection.length > 0) {
      this.selectedComplexFilters = [...this.preSelection]
    }
  }
}
</script>

<style scoped>
.complex-filter-list-item {
  height: 80px !important;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 22px 48px;
  border-radius: 8px;
  border: 1px solid #b2bec3;
  color: #00903c;
  cursor: pointer;
  font-weight: 700;
  font-size: 20px;
}
.complex-filter-list-item.selected {
  background-color: #00903c;
  color: #fff;
}
</style>
